import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";
import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';
// import ProfileImage3 from './assets/images/profile3.png';
// import myProfilePic from '../../../assets/images/profile3.png'; 

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class ProductFeatures extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
                <Helmet>
  <title>Healthcare Software Features | EMR, Billing & Telehealth | KlinicQ</title>

  <meta 
    name="description" 
    content="Explore KlinicQ healthcare software features including EMR, smart billing, tele-consultation, appointment scheduling, pharmacy management, and advanced analytics designed for clinics and hospitals." 
  />

  <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": "https://www.klinicq.com/features",
  "name": "KlinicQ Healthcare Management Software",
  "applicationCategory": "BusinessApplication",
  "applicationSubCategory": "Healthcare Management Software",
  "operatingSystem": "Web",
  "softwareVersion": "1.0",
  "description": "KlinicQ is an all-in-one cloud-based healthcare management software offering EMR, smart billing, tele-consultation, appointment scheduling, pharmacy management, and analytics for hospitals and clinics.",
  "featureList": [
    "Electronic Medical Records (EMR)",
    "Smart Billing and Invoicing",
    "Tele-consultation",
    "Appointment Scheduling",
    "Patient Management System",
    "Pharmacy and Inventory Management",
    "Analytics and Reports",
    "Secure Cloud-Based Access"
  ],
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "offers": {
    "@type": "Offer",
    "availability": "https://schema.org/InStock",
    "url": "https://www.klinicq.com/contact",
    "description": "Contact for pricing or request a free demo"
  },
  "provider": {
    "@type": "Organization",
    "name": "KlinicQ",
    "url": "https://www.klinicq.com"
  },
  "url": "https://www.klinicq.com/features"
})}
</script>
</Helmet>


                <div className="">
                   
                    <div className="">
                       

<div className='product-section'>
    <Headerweb/>
     

            <div className="desktop-wrapper">
             <div className="desktop">
 <div className="overlap-wrapper1">
        <div className="overlap">
         
          {/* <img className="group" src={require("../../src/assets/images/website/benifits bg.png")} alt="" aria-hidden="true"/> */}
          <div className="content-section">
            <h1 class="">
             Nucleo Software Solution Empowering Healthcare Through Innovative Technology
            </h1>
            <div class="highlight-box">
              <div class="rectangle-2"></div>
              <p class="highlight-text">
                 In the rapidly evolving landscape of life sciences and healthcare, 
            Nucleo Software Solutions stands as your trusted partner, delivering 
            unparalleled business consulting and Information Technology services.
              </p>
            </div>
            
            
          </div>
          <div class="doctor-image-wrapper">
            <div class="doctor-background"></div>
            <img
              class="doctor-image"
              src={require("../../src/assets/images/website/about doctor.png")}
              alt="Doctor using healthcare technology solutions for digital patient care"
            />
          </div> 
         
          <div class="info-card">
            <img
              class="info-card-image"
              src={require("../../src/assets/images/website/about Rectangle.png")}
              alt="Advanced medical technology equipment used in modern healthcare"
            />
            <h2 class="info-card-title">Best Medical</h2>
            <p class="info-card-text">Rapidiously reinvent long-term impact collaboration</p>
          </div>
           <img class="union" src={require("../../src/assets/images/website/Union.png")} alt=" " aria-hidden="true"/>
          <div class="contact-info">
            <img
              class="contact-icon"
              src={require("../../src/assets/images/website/Union img.png")}
              alt="" aria-hidden="true"
            />
            <p class="contact-label">Have a Question?</p>
            <p class="contact-email">info@klinicq.com</p>
          </div>
          <img
            class="decorative-group"
            src={require("../../src/assets/images/website/about star.png")}
            alt="" aria-hidden="true"
          />
          <img
            class="decorative-frame"
            src={require("../../src/assets/images/website/about startL.png")}
            alt="" aria-hidden="true"
          />
        
        </div>
      </div>
      </div>
             
        <div className="container-features">
            
             <div className="feature-item">
        <div className="feature-image-container">
            <img src={require("../../src/assets/images/website/223.webp")} 
                 alt="Electronic medical records software interface for clinics and hospitals" 
                 className="feature-image" />
        </div>
        <div className="feature-content">
            <h2>Electronic Medical Records ( EMR )</h2>
                    <p className="feature-description">The KlinicQ application maintains the patient's medical records, which include the health history, lab records, discharge summary, prescription details, vitals.</p>
                    <p className="feature-description">KlinicQ application software security is a role-based access configuration for doctors, hospitals, and patients.</p>
                    <p className="feature-description">Patient discharge summary generated based on check-out after treatment, including the visit's reason, diagnosis information, vitals, and prescription details.</p>
                    <p className="feature-description">The data is stored in the cloud so that the ability to transfer the patient data from one clinic/department to the next will be quick.</p>
                    <p className="feature-description">The KlinicQ application is customizable & scalable depending on the data volume to store the electronic medical records that can grow with your practice.</p>
                    {/* <p className="feature-description">Improve the operational efficiency and reduce the documentation searching time, maintain paper records & also the space-saving of a digital record environment</p> */}
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">01</span>
                </div> */}
            </div>

            
           <div className="feature-item reverse">
        <div className="feature-image-container">
            <img src={require("../../src/assets/images/website/product integrated.webp")} 
                 alt="Integrated healthcare management platform connecting EMR, pharmacy, and lab" 
                 className="feature-image" />
        </div>
        <div className="feature-content">
            <h2>Integrated Solution</h2>
                    <p className="feature-description">All medical records—diagnoses, prescriptions, lab results—are stored in one place, ensuring seamless access for doctors, nurses, and patients across departments or facilities.</p>
                    <p className="feature-description">The solution connects with EHRs, pharmacy systems, labs, and insurance platforms using standards like HL7 or FHIR, enabling real-time data exchange and reducing manual entry.</p>
                    <p className="feature-description">Video consultations, wearable device integration, and home monitoring tools are embedded, allowing proactive care for chronic conditions and remote patients.</p>
                    <p className="feature-description">Tasks like appointment scheduling, referrals, and follow-ups are automated, improving efficiency and ensuring patients don’t fall through the cracks.</p>
                    <p className="feature-description">Dashboards track key metrics like readmission rates, medication adherence, and patient satisfaction—supporting data-driven decisions and value-based care.</p>
                    {/* <p className="feature-description">The platform is cloud-based, mobile-friendly, and compliant with data privacy laws (like HIPAA or India’s DISHA), ensuring secure access for both providers and patients.</p> */}
                </div>
                {/* <div class="feature-number left">
                    <span class="feature-number-text">02</span>
                </div> */}
            </div>

            
          <div className="feature-item">
        <div className="feature-image-container">
            <img src={require("../../src/assets/images/website/product expensive.webp")} 
                 alt="Cloud based healthcare software running without expensive hospital hardware" 
                 className="feature-image" />
        </div>
        <div className="feature-content">
            <h2>No expensive Hardware</h2>
                    <p className="feature-description">The entire system runs on secure cloud servers, eliminating the need for on-premise servers, data centers, or high-maintenance IT hardware.</p>
                    <p className="feature-description">Doctors, nurses, and patients can access the platform from any smartphone, tablet, or basic laptop—no need for specialized terminals or kiosks.</p>
                    <p className="feature-description">The solution supports API-based connections with labs, pharmacies, and diagnostic tools, avoiding the need for proprietary hardware or custom-built bridges.</p>
                    <p className="feature-description">KlinicQ with responsive web apps and mobile apps, the system works seamlessly on low-cost Android or iOS devices, making it accessible in rural or resource-limited settings.</p>
                    <p className="feature-description">Instead of expensive hospital-grade monitors, the platform can integrate with affordable wearables (like smartwatches or Bluetooth BP monitors) for real-time vitals tracking.</p>
                    {/* <p className="feature-description">No need for IT teams to install or maintain physical infrastructure—updates, backups, and security patches are handled remotely by the provider.</p> */}
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">03</span>
                </div> */}
            </div>

           
          <div className="feature-item reverse">
        <div className="feature-image-container">
            <img src={require("../../src/assets/images/website/product mobile.webp")} 
                 alt="Modular and scalable healthcare software architecture diagram" 
                 className="feature-image" />
        </div>
        <div className="feature-content">
            <h2>Modular & Scalable Architecture</h2>
                    <p class="feature-description">Each module handles a specific responsibility—like EMR, billing, or telehealth—making the system easier to develop, test, and maintain independently.</p>
                    <p className="feature-description">New features (e.g., pharmacy integration or analytics dashboards) can be added or removed without disrupting the core system, enabling faster innovation and customization.</p>
                    <p className="feature-description">Modules can scale individually based on demand. For example, if teleconsultations spike, only that service needs more resources—saving cost and improving performance.</p>
                    <p className="feature-description">Modules communicate through well-defined APIs or service contracts, reducing dependencies and allowing teams to work in parallel without breaking the system.</p>
                    <p className="feature-description">Since modules are isolated, updates or bug fixes can be deployed to one part of the system without requiring a full system redeploy—minimizing downtime.</p>
                    {/* <p className="feature-description">You can upgrade or replace individual modules (e.g., switch from one payment gateway to another) without rewriting the entire platform—ensuring long-term flexibility.</p> */}
                </div>
                {/* <div class="feature-number left">
                    <span class="feature-number-text">02</span>
                </div> */}
            </div>

            
             <div className="feature-item">
        <div className="feature-image-container">
            <img src={require("../../src/assets/images/website/product-hospital-monitor.webp")} 
                 alt="Offline access healthcare application with automatic data synchronization" 
                 className="feature-image" />
        </div>
        <div className="feature-content">
            <h2>Offline Access & Auto-Sync</h2>
                    <p className="feature-description">Users can access patient records, forms, and essential data even without internet connectivity—ideal for rural clinics, mobile health units, or emergency response teams.</p>
                    <p className="feature-description">Once the device reconnects to the internet, all offline updates (like new entries, edits, or uploads) are automatically synced to the cloud—no manual intervention needed.</p>
                    <p className="feature-description">If multiple users edit the same record offline, the system detects conflicts and prompts for resolution or merges changes intelligently to maintain data integrity.</p>
                    <p className="feature-description">Only relevant data (e.g., assigned patients or scheduled appointments) is downloaded to the device, optimizing performance All offline data is encrypted and stored securely on the device, ensuring compliance with privacy regulations like HIPAA or DISHA.</p>
                    {/* <p className="feature-description">Visual cues (like sync status icons or timestamps) inform users when data is pending, syncing, or successfully updated—boosting confidence and transparency.</p> */}
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">03</span>
                </div> */}
            </div>
        </div>
    </div>                     
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
   
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(ProductFeatures);